// ConsolidatedOrder.js
// Data object for handling multiple orders as a single consolidated order
import Order from "./Order";

// Class Definition
class ConsolidatedOrder {
  constructor(products, orders) {
    this.products = products;
    this.orders = orders;
    this.data = [];

    this.orders.forEach(order => {
      this.data.push(new Order(products, order));
    });
  }

  hasProduct = (prodId) => {
    for (var i = 0; i < this.orders.length; i++) {
      if (this.orders[i][prodId])
        return true;
    }
    return false;
  }

  getQuantity = (prodId, unit) => {
    var total = 0
    this.data.forEach(order => {
      if (order.getUnit(prodId) === unit)
        total += order.getQuantity(prodId);
    });
    return total;
  }

  getUnits = (prodId) => {
    var units = []
    var selected = {}
    this.data.forEach(order => {
      var unit = order.getUnit(prodId);
      if (unit !== null && !selected[unit]) {
        units.push(unit);
        selected[unit] = true;
      }
    });
    return units;
  }

  hasCustomPrice = (prodId) => {
    for (var i = 0; i < this.data.length; i++) {
      if (this.data[i].hasCustomPrice())
        return true;
    }
    return false;
  }

  getProductTotal = (prodId, unit) => {
    var total = 0
    this.data.forEach(order => {
      if (order.getUnit(prodId) === unit)
        total += order.getProductTotal(prodId);
    });
    return total;
  }

  getAdjustmentList = () => {
    var adjustments = [];
    this.data.forEach(order => {
      if (order.getAdjustmentValue() !== 0) {
        adjustments.push({
          date: order.getDateClosed(),
          value: order.getAdjustmentValue(),
          description: order.getAdjustmentDescription()
        });
      }
    });
    return adjustments;
  }

  getSubtotal = () => {
    var total = 0;
    this.data.forEach(order => {
      total += order.getSubtotal();
    });
    return total;
  }

  getTotal = () => {
    var total = 0;
    this.data.forEach(order => {
      total += order.getTotal();
    });
    return total;
  }
}

// Default Export
export default ConsolidatedOrder;


// WEBPACK FOOTER //
// ./src/data/ConsolidatedOrder.js